import { createSelector } from 'reselect'
import { getCanRedeemLuxPlusBenefits, getIsPendingRenewalLuxPlusMember } from 'luxPlus/selectors/featureToggle'
import { matchPath } from 'react-router'
import { LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'

const redirectPaths = [
  `/:region/${LUXURY_PLUS_PATHS.DEFAULT_LANDING_PAGE}`,
]

/**
 * We want to redirect to the account page from the landing page if the user is a LuxPlus+ member and is either:
 * - eligible to redeem the benefits
 * - awaiting renewal
 */
const getLuxPlusShouldRedirectToAccountPage = createSelector(
  (state: App.State) => getCanRedeemLuxPlusBenefits(state),
  (state: App.State) => getIsPendingRenewalLuxPlusMember(state),
  (state: App.State) => state.router.location.pathname,
  (
    canRedeemLuxPlusBenefits,
    isPendingRenewalLuxPlusMember,
    pathname,
  ): boolean => {
    const isRedirectPath = !!matchPath(pathname, {
      path: redirectPaths,
      exact: false,
    })

    return (canRedeemLuxPlusBenefits || isPendingRenewalLuxPlusMember) && isRedirectPath
  },
)

export default getLuxPlusShouldRedirectToAccountPage
